// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-1-dh8","image":"index-image-3Wb9s","spacer":"index-spacer-2xKLD","item":"index-item-2PyWM","visuallyHidden":"index-visuallyHidden-1vQdP"};